// @ts-nocheck
(function () {
  if (window.__acehighMediaProgressInit) return;
  window.__acehighMediaProgressInit = true;

  const bind = (bar) => {
    if (bar.dataset.progressBound === '1') return;
    const slideshow = bar.closest('slideshow-component');
    if (!slideshow) return;
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) return;

    bar.dataset.progressBound = '1';

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const progress = max > 0 ? scroller.scrollLeft / max : 0;
      bar.style.setProperty('--progress', progress.toFixed(4));
    };

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const bindAll = (root = document) => {
    root.querySelectorAll('.product-media__progress-bar').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindAll());
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', (e) => bindAll(e.target));

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.product-media__progress-bar')) {
          bind(node);
        } else if (node.querySelectorAll) {
          bindAll(node);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
